"use client";

import {
  useEntityBase
} from "./chunk-BGEO5REY.mjs";
import {
  AutumnContext
} from "./chunk-EOSHPHLH.mjs";

// src/libraries/react/hooks/useEntity.tsx
var useEntity = (entityId, params) => {
  return useEntityBase({ AutumnContext, entityId, params });
};

export {
  useEntity
};
